import { render, staticRenderFns } from "./MyNoteDetail.vue?vue&type=template&id=f58faaa2&"
import script from "./MyNoteDetail.vue?vue&type=script&lang=js&"
export * from "./MyNoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyNoteDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports